import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { BasePopup } from 'components/Display/BasePopup/BasePopup';
import { Button } from 'components/Form/Button/Button';

type SkipDeliveryConfirmationModalProps = {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

export const SkipDeliveryConfirmationModal: FC<SkipDeliveryConfirmationModalProps> = ({
  open,
  onConfirm,
  onCancel,
}) => {
  const { t } = useTranslation();

  return (
    <BasePopup open={open} setOpen={onCancel}>
      <BasePopup.Body>
        <h1 className="text-lg font-semibold text-gray-900">
          {t('transactions:show.sections.alert.review.documentChanged.confirmSkipDelivery.title')}
        </h1>
        <div className="mt-2 flex flex-col gap-6">
          <p className="text-sm text-gray-500">
            {t('transactions:show.sections.alert.review.documentChanged.confirmSkipDelivery.description')}
          </p>
          <div className="flex items-center justify-end gap-2">
            <Button variant="secondary" onClick={onCancel} analyticsId="pending-review-banner-cancel-skip-delivery">
              {t('common:cancel')}
            </Button>
            <Button variant="primary" onClick={onConfirm} analyticsId="pending-review-banner-confirm-skip-delivery">
              {t('transactions:show.sections.alert.review.documentChanged.confirmSkipDelivery.actionTitle')}
            </Button>
          </div>
        </div>
      </BasePopup.Body>
    </BasePopup>
  );
};
